module.exports = __webpack_public_path__ + "static/media/banner_420x230_5.8cc40c75.jpg";